export class ROUTES {
    public static LOGIN = `/authentication`;
    public static ADMIN = `/admin`;
    public static DIGITALTWIN_GEO = `/map/geo-digitaltwin`;
    public static DIGITALTWIN = '/digitaltwin';
    public static UNAUTHORIZED = '/unauthorized';
    public static CHANGE_PASSWORD = '/authentication/change-password';
}
